<script setup>
import { inject, ref, computed, watch } from 'vue';
import { getPrettyPrice } from '../shared/utils';
import useCartStore from '../store/cart';
import useOrderStore from '../store/order';
import { useCustomerStore } from '../store/customer';
import { useScheduleStore } from '../store/schedule';
import router from '../routes';
import { useRoute } from 'vue-router'
import ModalHead from './ModalHead.vue';
import ModalFooter from './ModalFooter.vue';
import ModalBtn from './ModalBtn.vue';
import PaymentAdditional from './PaymentAdditional.vue';
import { useCloverSDK } from '@client/js/composables/useCloverSDK.js';

const emit = defineEmits(['close']);

const { isSdkReady } = useCloverSDK();
const route = useRoute(); // modal router

const cartStore = useCartStore();
const customerStore = useCustomerStore();
const scheduleStore = useScheduleStore();
const orderStore = useOrderStore();

const rootData = inject('rootData');
const restApi = inject('restApi');

const loading = ref(false)
const errorMessage = ref('')
const responseMessage = ref('')
const orderIdFromResponse = ref(null)
const unpaid = ref(0)

const hasUnpaid = computed(() => Number(unpaid.value) > 0)

const fetchOrderPayment = async (id) => {
    if (!id) return

    loading.value = true
    errorMessage.value = ''
    responseMessage.value = ''
    orderIdFromResponse.value = null
    unpaid.value = 0

    try {
        const response = await restApi.get('clover/check-order-payment', {
            params: {
                orderId: id,
                message: '',
            }
        })

        const payload = response?.data ?? response

        responseMessage.value = payload?.message || ''
        orderIdFromResponse.value = payload?.data?.order_id ?? null
        unpaid.value = Number(payload?.data?.unpaid ?? 0)
    } catch (error) {
        errorMessage.value =
            error?.response?.data?.message ||
            error?.message ||
            'Request failed'
    } finally {
        loading.value = false
    }
}

watch(
    () => route.params.id,
    (id) => {
        fetchOrderPayment(id)
    },
    { immediate: true }
)

const returnToMenu = () => {
    // orderStore.orderId = '';
    orderStore.paymentStatus = '';
    orderStore.paymentMessage = '';
    emit('close');
    cartStore.clear();
    router.push('/cart/');
}
</script>

<template>
    <ModalHead>Order Payment State: <strong>{{ route.params.id }}</strong></ModalHead>
    <div class="modal__body">
        <!-- <PaymentAdditional v-if="isSdkReady && rootData?.ordering?.flow == 'one'" /> -->
        <div v-if="loading">Loading...</div>

        <div v-else>
            <div v-if="errorMessage">
                {{ errorMessage }}
            </div>

            <template v-else>
                <div>{{ responseMessage }}</div>


                <div v-if="hasUnpaid">
                    Unpaid: {{ getPrettyPrice(unpaid) }}
                    <hr>
                    <PaymentAdditional v-if="isSdkReady && rootData?.ordering?.flow == 'one' && hasUnpaid"
                        :orderId="orderIdFromResponse" :amount="unpaid" :email="customerStore.email"/>                
                </div>

            </template>
        </div>
    </div>
    <ModalFooter>
        <ModalBtn class="btn-primary" @click="returnToMenu()" role="link">Return to menu</ModalBtn>
    </ModalFooter>
</template>

<style lang="scss">
.cart-total {
    font-size: 0.875rem;

    dl {
        padding: 1rem;
        margin: 0;
        border-top: 1px solid var(--text-secondary);
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        gap: 0.25rem 0.5rem;
    }

    dt,
    dd {
        // margin: 0 0 .375em;
        &:last-of-type {
            margin-bottom: 0;
        }
    }

    dt {
        grid-column: span 8;
    }

    dd {
        grid-column: span 4;
        text-align: right;
    }

    .totalRow {
        font-weight: 600;
    }
}
</style>